<script lang="ts">
    import type { TMarket } from '$lib/services/market/types';
    import ROUTE_IDS from '$src/generated/routeIds';
    import { getRoute } from '$src/lib/services/navigation';
    import { ERROR_MESSAGES } from './error-messages';
    import ErrorMessagePage from './ErrorMessagePage.svelte';

    export let market: TMarket;

    const { title, info, buttonText } = ERROR_MESSAGES[market.slug] || ERROR_MESSAGES['en']!;
    const href = getRoute(ROUTE_IDS.HOME) ?? '/';
</script>

<ErrorMessagePage icon="not-found-pictogram" {title} {info} {buttonText} {href} />
